module.exports = __webpack_public_path__ + "static/sun_frozen-25deb0f683d7fe099f65b9f30bb4c1e9.png";